interface DetailItemProps {
  label: string;
  value: string | React.ReactNode;
  highlight?: boolean;
  icon?: React.ElementType;
}

export const DetailItem = ({
  label,
  value,
  highlight = false,
  icon: Icon,
}: DetailItemProps) => (
  <div
    className={`py-3 border-b last:border-0 ${highlight ? "bg-green-50 dark:bg-green-950/20 -mx-4 px-4" : ""}`}
  >
    <div className="flex items-start justify-between">
      <div className="flex items-start gap-2 min-w-0">
        {Icon && (
          <Icon
            className="w-4 h-4 text-muted-foreground shrink-0"
            style={{ marginTop: "2px" }}
          />
        )}
        <p className="text-sm text-muted-foreground leading-5">{label}</p>
      </div>
      <div className="text-base font-medium text-right ml-4 min-w-0 leading-5">
        {value}
      </div>
    </div>
  </div>
);
